module.exports = __webpack_public_path__ + "static/media/acosta.c06d01af.svg";